export enum RoutePath {
  FrontPage = '/',
  Facilities = '/facilities',
  ReleasesToAir = '/releases/toAir',
  ReleasesToWater = '/releases/toWater',
  WasteTransfers = '/wasteTransfers',
  AirPollutants = '/airPollutants',
  AdditionalInfo = '/additionalInfo',
  PollutantInfoTable = '/pollutantInfoTable'
}
